export interface GroupingOptionItem {
    columnTitle: string;
    title?: string;
}

export const groupingOptions = Object.freeze({
    none: { columnTitle: 'None' },
    visit: { columnTitle: 'Visit' },
    subject: {
        columnTitle: 'Subject',
        title: 'Subject'
    }
});